import { render } from "./ExamPatientAddFormData.vue?vue&type=template&id=021b5588&scoped=true"
import script from "./ExamPatientAddFormData.vue?vue&type=script&lang=js"
export * from "./ExamPatientAddFormData.vue?vue&type=script&lang=js"

import "./ExamPatientAddFormData.vue?vue&type=style&index=0&id=021b5588&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021b5588"]])

export default __exports__